import React, {Component, PropTypes} from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import css from './index.css';
import {hasAuth} from "../../../utils/NHCore";
import NHTable from "../../common/NHTable";

const baseUrlPath = "/tjcx/zzbdblcx"; //基础路径


/**
 * Zzbdblcx汇总
 * @author sujunming
 * @date 2018-06-26 15:56:14
 * Version: 1.0
 */
export default class ZzbdblcxTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
        }
    }



    componentWillMount() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }
        ];
        this.setState({
            columns: columnConst,
        }, () => {
            this.getColumn();
        });
    }

    //获取动态字段
    getColumn = () => {

        NHFetch(baseUrlPath + "/getZzbdList", "get").then(
            res => {
                if (res.data) {
                    let columnLet = this.state.columns;
                    res.data.map((item, key) => {
                        let column = {
                            title: item.HJMC,
                            width: '150px',
                            dataIndex: "a" + key,
                            // render: (text) => {
                            //     return text == '已办理' ?
                            //         <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                            //         : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>;
                            // }
                        };
                        columnLet.push(column);
                    });
                    this.setState({
                        columns: columnLet
                    });
                }
            }
        )


    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('自助报到办理查询');
    }

    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 230}}>
                <div className={css.table}>
                    <NHTable ref='nhTable'
                                   rowKey={record => record.PKID}//TODO 把此处的信息改成自己的
                                   columns={this.state.columns}
                                   sign={"zhxg_yxxt_tjcx_zzbdxq_queryPage"}
                                   url={"/tjcx/zzbdblcx/gridList"}
                    >
                        {hasAuth("zhxg_yxgl_tjcx_zzbdblcx:export") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                    </NHTable>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/zzbdblcx/zzbdblcxTab.js